<template>
  <div class="supplierTable">
    <div class="topBar">
      <div>
        <el-input
          v-model="keyword"
          clearable
          placeholder="请输入供应商名称进行查询"
          size="small"
          style="width: 300px; margin-right: 10px"
          @clear="search"
          @keydown.native.enter="search"
        ></el-input>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>
      <div>
        <el-button size="small" type="primary" @click="add"
          >添加供应商</el-button
        >
      </div>
    </div>
    <div style="height: 60px"></div>
    <el-table
      :data="data"
      style="width: 100%"
      height="calc(100vh - 200px)"
      size="mini"
    >
      <el-table-column label="供应商编号" prop="cVenCode" sortable>
      </el-table-column>
      <el-table-column
        label="供应商名称"
        prop="cVenName"
        align="left"
        sortable
      ></el-table-column>
      <el-table-column
        label="联系人"
        prop="cVenPerson"
        align="left"
        sortable
      ></el-table-column>
      <el-table-column
        label="手机号"
        prop="cVenPhone"
        align="left"
        sortable
      ></el-table-column>
      <!-- <el-table-column label="备注" prop="Remarks"></el-table-column> -->

      <el-table-column align="center" label="操作" prop="action" width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button
            type="text"
            v-if="!scope.row.IsRegister"
            @click="del(scope.row.Id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.PageIndex"
        :page-sizes="pagination.PageSizes"
        :page-size="pagination.PageRows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
    <SupplierForm ref="supplierform" @comfirm="SupplierFormComfirm" />
  </div>
</template>
<script>
const reg = /^1[345789]\d{9}$/
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex'
import SupplierForm from './SupplierForm.vue'

export default {
  components: {
    SupplierForm,
  },
  data() {
    return {
      data: [],
      inviteUrl: '', // 邀请链接
      allArr: [], // 查询前数据
      keyword: '',
      dialogVisible: false,
      invitePhone: '',
      invitePhoneVisible: false,
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
    }
  },
  mounted() {
    this.getDataList()
    this.inviteUrl =
      location.href.split('M')[0] + 'NoT/invite?UserId=' + this.userInfo.Id
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },

    async SupplierFormComfirm() {
      await this.getDataList()
    },

    add() {
      this.$refs.supplierform.open({}, '添加供应商')
    },
    // 编辑
    edit(obj) {
      this.$refs.supplierform.open(obj, '编辑供应商')
    },
    // 删除
    del(Id) {
      this.$confirm('此操作将删除该供应商, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http
            .post('/Base_BasicData/Base_Supplier/DeleteData', [Id])
            .then(async (res) => {
              console.log(res)
              if (res.Success) {
                await this.getDataList()
              } else this.$notify.error(res.Msg)
            })
        })
        .catch(() => {})
    },

    // 复制邀请链接
    copyUrl() {
      var input = document.createElement('input') // 创建input对象
      input.value = this.inviteUrl // 设置复制内容
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand('Copy') // 执行复制
      document.body.removeChild(input) // 删除临时实例
      this.$notify.success('复制成功！')
    },
    // 列表查询
    search() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    // 数据源
    async getDataList() {
      await this.$http
        .post('/Base_BasicData/Base_Supplier/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,

          SortField: 'Id',
          SortType: 'desc',

          Search: {
            Condition: 'cVenName',
            Keyword: this.keyword,
          },
        })
        .then((res) => {
          if (res.Success) {
            this.data = res.Data
            this.pagination.total = res.Total
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-avatar img {
  display: block;
  height: 100%;
  width: 100%;
  vertical-align: middle;
}

.supplierTable {
  width: 100%;
  padding: 10px;
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
  height: 100%;
  padding-top: 30px;
  box-sizing: border-box;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    /* 滚动条里面小方块 */
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #e0e0e0;
  }

  &::-webkit-scrollbar-track {
    /* 滚动条里面轨道 */
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    // border-radius: 10px;
    background: transparent;
  }

  .topBar {
    position: fixed;
    width: 100%;
    height: 60px;
    left: 0px;
    top: 61px;
    z-index: 999;
    display: flex;
    padding: 0 10px;
    background: #ebeef5;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
  }

  .invite {
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    div {
      text-align: left;
    }

    .line {
      width: 1px;
      height: 100%;

      div {
        height: 100px;
        width: 1px;
        background: #ccc;
        margin: 0 auto;
      }
    }
  }
}
</style>
